// extracted by mini-css-extract-plugin
export var changeIcon = "_4t-4";
export var container = "_4t-0";
export var divider = "_4t-7";
export var externalLinkIcon = "_4t-1";
export var green = "_4t-5";
export var helpCircleIcon = "_4t-3";
export var iconButton = "_4t-2";
export var red = "_4t-6";